import React, { useEffect, useState, useRef } from 'react'; 
import { AppBar, Box, Modal, Typography, Button } from '@mui/material'; 
import { DataGrid, GridToolbar, GridToolbarContainer } from '@mui/x-data-grid'; 
import { useServiceContext } from '../../components/Context/ServiceContext'; 
const style = { 
    position: 'absolute', 
    top: '50%', left: '50%', 
    transform: 'translate(-50%, -50%)', 
    width: 400, bgcolor: 'background.paper', 
    border: '2px solid #000', boxShadow: 24, p: 4, 
}; 
    const DisputeAdminView = () => { 
        const [loading, setLoading] = useState(true); 
        const [disputedata, setDisputeData] = useState([]);
        const [selectedDescription, setSelectedDescription] = useState(''); 
        const [open, setOpen] = useState(false); 
        const { disputeviewbyadmin } = useServiceContext(); 
        const didFetch = useRef(false); 
        const getData = async () => {
             try {
                 const data = await disputeviewbyadmin(); 
                 console.log(data);
                setDisputeData(data); setLoading(false); 
            } catch (error) { 
                console.log(error); } 
        }; 
        const handleOpen = (description) => { setSelectedDescription(description); setOpen(true); }; 
        const handleClose = () => setOpen(false); 
        const confirmDescription = () => { alert('Description confirmed!'); setSelectedDescription(''); handleClose(); };
         useEffect(() => { 
            if (!didFetch.current) {
                 getData(); didFetch.current = true;
             } 
        }, [getData]);  
        const truncateDescription = (description) => { 
            const maxLength = 20; 
             if (description.length > maxLength) { 
                return `${description.substring(0, maxLength)}...`; 
            } 
                return description;
        }; 
        const columns = [ 
            { field: 'link', headerName: 'Link', width: 150, renderCell: () => (<i className="bi bi-info-circle"></i>) }, 
            { field: 'name', headerName: 'Name', width: 150 }, { field: 'email', headerName: 'Email', width: 150 }, 
            { field: 'phone', headerName: 'Contact', width: 150 }, 
            { field: 'description', headerName: 'Message', width: 200, renderCell: (params) => ( <span onClick={() => handleOpen(params.value)} style={{ cursor: 'pointer', color: 'blue'}}> {truncateDescription(params.value)} </span> )} ]; 
            const CustomToolbar = () => ( 
                <GridToolbarContainer> 
                    <GridToolbar />
                 </GridToolbarContainer> ); 
    return ( 
        <main id="main" className="main"> 
            <div className="pagetitle"> 
                <h1>Dispute Admin View</h1> 
                    <nav> 
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"> 
                                <a href="/admin">Home</a> 
                            </li> 
                         </ol> 
                    </nav> 
            </div> 
            <section className="section"> 
                <div className="row"> 
                    <div className="col-lg-12"> 
                        <div className="card"> 
                            <div className="card-body"> 
                                <h5 className="card-title"></h5> 
                                    <Box sx={{ width: '100%' }}> 
                                     <AppBar position="static" color="default">
                                        </AppBar> </Box> <div style={{ height: 400, width: '100%' }}> 
                                            <DataGrid rows={disputedata} columns={columns}
                                                slots={{ toolbar: CustomToolbar }} 
                                                components={{ Toolbar: GridToolbar }} 
                                                loading={loading} 
                                            /> 
                            </div> 
                                <Modal open={open} onClose={handleClose} aria-labelledby="modal-title" aria-describedby="modal-description" > 
                                    <Box sx={style}> 
                                        <Typography id="modal-title" variant="h6" component="h2"> Full Description </Typography> 
                                        <Typography id="modal-description" sx={{ mt: 2 }}> {selectedDescription} </Typography> 
                                        <Button onClick={confirmDescription} sx={{ mt: 2 }}>Confirm</Button>
                                    </Box> 
                                </Modal> 
                            </div> 
                        </div> 
                    </div> 
                </div> 
            </section> 
        </main> 
    ); 
}; export default DisputeAdminView;